import AppRights from "../../services/AppRights";
import { _ACTIVITIES, _ROLES_BACK } from "../../utils/constants";
import { useContext, useState, useEffect } from "react";
import { UserContext } from "../../contexts/UserContext";
import { getDataGeneric } from "../../repository/DataGeneric";
import FormTitle from "../../components/helpers/FormTitle";
import { _ROUTES } from "../../utils/_routes_constants";
import { RequestHelper } from "../../utils/requestHelper";
import { Box } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BasicFormikForm } from "../../components/form/BasicFormikForm";
import FormFilter from "../../components/budget/forms/FormFilter";
import { buildOptions } from "../../utils/formHelper";
import TablePlumsSplitSource from "../../components/budget/inputPlumsSplitSource/TablePlumsSplitSource";
import ColumnBuilder from "../../components/budget/inputPlumsSplitSource/ColumnBuilder";
import NoDataAvailableInput from "../../components/budget/NoDataAvailableInput";
import {
  CellSelectionModule,
  ExcelExportModule,
  RowGroupingModule,
  ClipboardModule,
  ColumnMenuModule,
  ContextMenuModule,
} from "ag-grid-enterprise";
import {
  AllCommunityModule,
  ModuleRegistry,
  ClientSideRowModelModule,
  NumberEditorModule,
  TextEditorModule,
  ValidationModule,
} from "ag-grid-community";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  AllCommunityModule,
  ExcelExportModule,
  RowGroupingModule,
  CellSelectionModule,
  TextEditorModule,
  ClipboardModule,
  ColumnMenuModule,
  NumberEditorModule,
  ValidationModule,
  ContextMenuModule,
]);
const InputPlumsSplitSource = () => {
  const [budgetParameters, setBudgetParameters] = useState([]);
  const [params, setParams] = useState({});
  const [rows, setRows] = useState([]);
  const [activityLRL, setActivityLRL] = useState([]);
  const [columns] = useState(ColumnBuilder(budgetParameters?.[0]));
  const [options, setOptions] = useState({
    site: [],
  });
  const { user } = useContext(UserContext);
  const isUserLrlAllowed =
    user?.roles?.includes(_ROLES_BACK._ROLE_LRL) &&
    budgetParameters?.[0]?.dataEntryEnabledLrl;
  const rq = new RequestHelper();

  useEffect(() => {
    if (budgetParameters.length === 0) {
      getDataGeneric(
        rq,
        {},
        (d) => {
          setBudgetParameters(d);
          if (d && d.length > 0) {
            setParams((prevParams) => ({
              ...prevParams,
              fiscalYear: d[0].dataEntryFiscalYearDate,
              version: d[0].dataEntryFiscalYearVersion,
            }));
          }
        },
        _ROUTES.BUDGET_PARAMETERS,
        "Unable to retrieve budget parameters",
      );
    }
    if (activityLRL.length === 0) {
      getDataGeneric(
        rq,
        { code: _ACTIVITIES.LRU },
        (data) => {
          if (data.length > 0) {
            setActivityLRL(data.find((d) => d.code === _ACTIVITIES.LRU));
          }
        },
        _ROUTES.ACTIVITIES,
        "Unable to retrieve activity LRU rows",
      );
    }
    if (options.site.length === 0) {
      getDataGeneric(
        rq,
        {
          pagination: false,
          active: 1,
          activities: [activityLRL?.id],
          "exists[sources]": 1,
          "order[name]": "ASC",
          "groups[]": "select:get",
          "sources.active": 1,
        },
        (data) => {
          setOptions((prevOptions) => ({
            ...prevOptions,
            site: buildOptions(data, "name", "id"),
          }));
        },
        _ROUTES.SITES,
        "Unable to retrieve sites",
      );
    }
  }, []);

  const v = Yup.object({
    site: Yup.string().required("Site is required").label("Site"),
  });

  const formik = useFormik({
    initialValues: {
      site: "",
    },
    validationSchema: v,
    onSubmit: (values) => {
      setParams((prevParams) => ({
        ...prevParams,
        site: values.site,
      }));
    },
  });

  formik["special"] = {
    customStructure: {
      0: ["site"],
    },
    layout: {
      site: {
        selectWidth: "40%",
        enableLeftLabel: true,
      },
    },
  };

  if (budgetParameters.length === 0) {
    return <NoDataAvailableInput />;
  }

  return (
    <>
      <AppRights
        roles={[
          _ROLES_BACK._ROLE_ADMIN,
          _ROLES_BACK._ROLE_CTRL,
          isUserLrlAllowed ? _ROLES_BACK._ROLE_PAYROLL : null,
        ]}
      />
      <Box width={"100%"}>
        <FormTitle title="Input plums split source" />
      </Box>
      <Box sx={{ width: "100%" }}>
        <Box
          p={2}
          sx={{
            backgroundColor: "white",
            display: "grid",
            gridTemplateColumns: "500px 1000px",
          }}
        >
          <BasicFormikForm formik={formik} validations={v} options={options} />
          <FormFilter formik={formik} budgetParameters={budgetParameters} />
        </Box>
        <Box>
          <TablePlumsSplitSource
            params={params}
            rows={rows}
            setRows={setRows}
            columns={columns}
            activityLRL={activityLRL}
          />
        </Box>
      </Box>
    </>
  );
};

export default InputPlumsSplitSource;
